import { View as rView } from "react-native";
import { styled } from "../css/styled";
export var View = styled(rView)();
